import React from "react";
/** @jsx jsx */
import {jsx, css, keyframes} from '@emotion/core';
import styled from "@emotion/styled";
import { colors } from "../ui";
import {useTransition, animated} from 'react-spring';

export const Alert = styled.div`
    width:100%;
    height:50px;
    background-color: ${props => colors[props.alert]};
    color:white;
    font-size:25px;
    line-height:50px;
    font-weight:300;
    text-align:center;
    border-radius:4px;
    `

export const Mycargando = ({loading}) => {

    const Cargando = styled.div`
        display: flex;
        flex-flow: column wrap;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
        position: fixed;
        background: white;
        z-index: 999;
        display: flex;

        small {
            color: #c0cbd6;
            display: block;
            margin-bottom: 1em;
        }

        .line {
            width: 80%;
            height: 6px;
            border-radius: 2px;
            background: #e4e4e4;
            overglow: hidden;
            padding:1px 0;

        .carga {
            height: 4px;
            width: 50px;
            background: #c0cbd6;
        }
        }
        `;

    const anima = keyframes`
        0%{width:2px; transform:translateX(0)}
        50%{width:20%;}
        100%{width:2px;transform:translateX( calc(80vw - 2px)) }

        `;

    const transitions = useTransition(loading, null, {
        from: {
            position: 'fixed',
            top: "0",
            left: "0",
            zIndex: "999",
            width: "100%",
            height: "100%",
            overflow: "hidden",
            opacity: 1
        },
        enter: {opacity: 1},
        leave: {opacity: 0, height: "0%"},
    });

    return transitions.map(
    ({ item, key, props }) =>
        item && (
            <animated.div key={key} style={props}>
                <Cargando>
                    <small>CONSULTANDO SERVICIOS, POR FAVOR ESPERE...</small>
                    <div className="line">
                    <div
                        className="carga"
                        css={css`animation: ${anima} 0.5s linear infinite alternate;`}
                    > </div>
                    </div>
                </Cargando>
            ️
            </animated.div>
        )
    );
};